module.exports = __webpack_public_path__ + "img/rinyushoku_g.96291ac0.png";